"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var satu_cookie_helper_1 = __importDefault(require("./satu-cookie-helper"));
var Client = /** @class */ (function () {
    function Client(loader, evidences, dataLayer) {
        this.trackedEvents = {};
        this.loader = loader;
        this.evidences = evidences;
        this.dataLayer = dataLayer || window.dataLayer;
    }
    /**
     * Return value of requested feature flag
     * Also track split result to DataHub
     */
    Client.prototype.resolveFeatureFlag = function (key, defaultValue) {
        return __awaiter(this, void 0, void 0, function () {
            var featureFlag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFeatureFlag({ key: key, defaultValue: defaultValue }, this.evidences)];
                    case 1:
                        featureFlag = _a.sent();
                        this.trackSplitResult(featureFlag, this.loader.satuId);
                        return [2 /*return*/, featureFlag.value];
                }
            });
        });
    };
    /**
     * Preload feature flags for current evidences
     */
    Client.prototype.warmup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loader.loadFeatureFlags(this.evidences)];
                    case 1:
                        _a.featureFlags = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Return value of requested feature flag
     * this.warmup() call is required
     */
    Client.prototype.resolveFeatureFlagSync = function (key, defaultValue) {
        var featureFlag = this.findOrDefault({ key: key, defaultValue: defaultValue });
        this.trackSplitResult(featureFlag, this.loader.satuId);
        return featureFlag.value;
    };
    /**
     * Change satu ID or/and list of evidences (after user sign-in, location changes, etc.)
     */
    Client.prototype.reset = function (options) {
        if (options === void 0) { options = {}; }
        var reset = false;
        var satuId = options.satuId || satu_cookie_helper_1.default.getSatuId();
        if (this.loader.reset(satuId)) {
            this.trackedEvents = {};
            this.featureFlags = undefined;
            reset = true;
        }
        if (options.evidences) {
            this.evidences = options.evidences;
            this.featureFlags = undefined;
            reset = true;
        }
        return reset;
    };
    /**
     * Internal method.
     *
     * Looking for given feature flag or return default value
     */
    Client.prototype.getFeatureFlag = function (request, evidences) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.featureFlags) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.loader.loadFeatureFlags(evidences)];
                    case 1:
                        _a.featureFlags = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.findOrDefault(request)];
                }
            });
        });
    };
    /**
     * Internal method
     *
     * Looking for requested feature flag or return default value
     */
    Client.prototype.findOrDefault = function (request) {
        var featureFlag = (this.featureFlags || []).find(function (item) { return item.name.toLowerCase() === request.key.toLowerCase(); });
        return featureFlag || {
            name: request.key,
            value: request.defaultValue,
        };
    };
    /**
     * Internal method
     *
     * Send split result to DataHub
     */
    Client.prototype.trackSplitResult = function (featureFlag, satuId) {
        var splitResult = featureFlag.splitResult;
        if (!splitResult) {
            return;
        }
        var event = {
            event: 'abtests',
            slot: splitResult.segmentId,
            'slot_value': "".concat(splitResult.testName, ":").concat(splitResult.testGroup),
            satu: satuId,
        };
        var eventKey = btoa(JSON.stringify(event));
        if (eventKey in this.trackedEvents) {
            return;
        }
        var dataLayer = this.dataLayer || window.dataLayer;
        if (dataLayer !== undefined) {
            dataLayer.push(event);
            this.trackedEvents[eventKey] = true;
        }
    };
    return Client;
}());
exports.default = Client;
//# sourceMappingURL=client.js.map